import { Grid, Divider, Box } from "@mui/material";
import { Fragment } from "react";
import { StatBox } from "./StatBox.tsx";
import { StatBoxItem } from "../types/StatBoxItem.ts";
import { useTheme } from "@mui/material/styles";

type StatBoxRowProps = {
  items: StatBoxItem[];
};

export const StatBoxRow = ({ items }: StatBoxRowProps) => {
  const theme = useTheme();
  return (
    <Grid container>
      <Grid size={12}>
        <Divider />
      </Grid>
      {items.map((item, index) => (
        <Fragment key={item.label}>
          <Grid
            size={{ xs: 6, md: 3 }}
            sx={{
              display: "flex",
              borderBottom: {
                xs:
                  index < items.length / 2
                    ? `1px solid ${theme.palette.elevation.outlined}`
                    : "none",
                md: "none",
              },
            }}
          >
            <Box
              sx={{
                paddingTop: { xs: 2, md: 2 },
                paddingBottom: { xs: 2, md: 2 },
                paddingLeft: {
                  xs: index % 2 !== 0 ? 2 : 0,
                  md: index === 0 ? 0 : 2,
                },
                paddingRight: { xs: 0, md: index === items.length - 1 ? 0 : 2 },
              }}
            >
              <StatBox
                label={item.label}
                value={item.value}
                description={item.description}
              />
            </Box>
            <Divider
              orientation="vertical"
              sx={{
                marginLeft: "auto",
                display: {
                  xs: index % 2 === 0 ? "block" : "none",
                  md: index < items.length - 1 ? "block" : "none",
                },
              }}
            />
          </Grid>
        </Fragment>
      ))}
      <Grid size={12}>
        <Divider />
      </Grid>
    </Grid>
  );
};
